// Centralized configuration file for the application

const config = {
  // API Configuration
  API: {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://143.110.141.92:3002/api',
    TIMEOUT: 10000, // 10 seconds
  },
  
  // Security Configuration
  SECURITY: {
    // Add any secret keys or security configs here if needed
    // Note: Never store actual secrets in frontend code
    TOKEN_KEY: 'token',
    SECRET_KEY: process.env.REACT_APP_SECRET_KEY || "lPhXzI3Fv;TF(>R",
  },
  
  // App Configuration
  APP: {
    NAME: 'GICPhotoAI Admin Panel',
    VERSION: '1.0.0',
    DEFAULT_ADMIN_EMAIL: 'admin@gicphotoai.com',
  },
  
  // Pagination and limits
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    MAX_PAGE_SIZE: 100,
  },
  
  // Toast notification settings
  NOTIFICATIONS: {
    DEFAULT_TIMEOUT: 3000,
    SUCCESS_TIMEOUT: 2000,
    ERROR_TIMEOUT: 5000,
  }
};

export default config;